export class WebInterfaceOptions {
  httpEnabled: boolean;
  httpPort: string;
  httpsEnabled: boolean;
  httpsPort: string;
  enabled: boolean;

  constructor() {
    this.httpEnabled = false;
    this.httpPort = '43210';
    this.httpsEnabled = false;
    this.httpsPort = '43211';
    this.enabled = false;
  }
}
